// prevent-dev-tools.service.ts
import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PreventDevToolsService {

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public disable() {
    // 1. Disable Right Click
    this.document.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    });

    // 2. Disable Keyboard Shortcuts
    this.document.addEventListener('keydown', (event: KeyboardEvent) => {
      // Disable F12
      if (event.key === 'F12') {
        event.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+I (Windows/Linux)
      if (event.ctrlKey && event.shiftKey && event.key === 'I') {
        event.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+J (Windows/Linux)
      if (event.ctrlKey && event.shiftKey && event.key === 'J') {
        event.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+C (Windows/Linux)
      if (event.ctrlKey && event.shiftKey && event.key === 'C') {
        event.preventDefault();
        return false;
      }
      // Disable Ctrl+U (View Source)
      if (event.ctrlKey && event.key === 'u') {
        event.preventDefault();
        return false;
      }
      return true;
    });
  }
}